import { css } from '@emotion/core'
import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getLastPathElement } from '../../../../../util/StringUtil'
import ActionButton from '../helpers/ActionButton'
import DetailHeader from '../helpers/DetailHeader'
import HiddenDetails from '../helpers/HiddenDetails'
import ItemBlock from '../helpers/ItemBlock'

const smallFont = css`
  font-size: 12px;
`
const mediumFont = css`
  font-size: 14px;
`
const largeFont = css`
  font-size: 16px;
`

export default function OtherInformation({ person, actionButtonOnClick, toggleShowItemHiddenDetails }) {
  const { t } = useTranslation()
  return (
    <>
      {person.otherInformation.map((item, index) => {
        const conclusion = item.value
        const itemType = getLastPathElement(conclusion.value.type)
        const showHiddenDetails = item.showHiddenDetails
        const actionButtonType = item.actionButtonType
        const actionButtonOnClickOtherItem = () => {
          actionButtonOnClick({ item: 'Other', actionButtonType, index })
        }
        return (
          <ItemBlock
            key={item.value.conclusionId}
            selected={actionButtonType === 'UNDO'}
            displayStatus={item.displayStatus}
            isSurvivingPerson={person.isSurvivingPerson}
          >
            <DataBlock
              heading={
                <DetailHeader
                  heading={itemType === 'USER_DEFINED' ? t('customEvent', 'Custom Event') : itemType}
                  showHiddenDetails={showHiddenDetails}
                  toggleShowItemHiddenDetails={() => toggleShowItemHiddenDetails({ item: 'Other', index })}
                />
              }
              data={<Data conclusion={conclusion} />}
            />
            <HiddenDetails person={person} conclusion={conclusion} showHiddenDetails={showHiddenDetails} />
            <ActionButton type={actionButtonType} onClick={actionButtonOnClickOtherItem} />
          </ItemBlock>
        )
      })}
    </>
  )
}

function Data({ conclusion }) {
  const { t } = useTranslation()
  let data = null
  if (getLastPathElement(conclusion?.value?.type) === 'USER_DEFINED') {
    data = (
      <>
        <span css={mediumFont}>{parseUserDefinedType(conclusion?.value?.userDefinedType)}</span>
        <br />
        {conclusion?.value?.userDefinedDataType === 'EVENT' && (
          <>
            <span css={mediumFont}>
              {conclusion?.value?.date?.normalized?.[0]?.value
                ? conclusion?.value?.date?.normalized?.[0]?.value
                : conclusion?.value?.date?.original}
            </span>
            <br />
            <span css={mediumFont}>
              {conclusion?.value?.place?.names?.[0]?.value
                ? conclusion?.value?.place?.names?.[0]?.value
                : conclusion?.value?.place?.original}
            </span>
            <br />
          </>
        )}
        <div css={smallFont}>{t('description', 'Description')}</div>
        <span css={mediumFont}>{conclusion?.value?.value}</span>
      </>
    )
  } else {
    data = (
      <>
        {conclusion?.value?.date && (
          <>
            <span css={mediumFont}>
              {conclusion?.value?.date?.normalized?.[0]?.value
                ? conclusion?.value?.date?.normalized?.[0]?.value
                : conclusion?.value?.date?.original}
            </span>
            <br />
          </>
        )}
        {conclusion?.value?.place && (
          <>
            <span css={mediumFont}>
              {conclusion?.value?.place?.names?.[0]?.value
                ? conclusion?.value?.place?.names?.[0]?.value
                : conclusion?.value?.place?.original}
            </span>
            <br />
          </>
        )}
        {conclusion?.value?.value && (
          <>
            {conclusion?.value?.place || conclusion?.value?.date ? (
              <>
                <div css={smallFont}>{t('description', 'Description')}</div>
                <span css={mediumFont}>{conclusion?.value?.value}</span>
              </>
            ) : (
              <span css={largeFont}>{conclusion?.value?.value}</span>
            )}
          </>
        )}
      </>
    )
  }
  return data
}

function parseUserDefinedType(userDefinedType) {
  return decodeURIComponent(userDefinedType.replace('data:,', '').replace(/\+/g, ' '))
}
